module.exports = __webpack_public_path__ + "img/selected5-min.d78e5960.png";